module.exports = __webpack_public_path__ + "static/media/undraw_online_test_gba7.6e6a7c56.svg";